<div class="page-not-found">
    <h6>OOPS! You Landed on wrong Page.</h6>
    <h6>Please <a class="pointer" (click)="partner()"> Click here</a></h6>
</div>